import React, { Component } from 'react';
import PropertyCard from '../PropertyCard/PropertyCard';
import styles from './Explore.scss';

export const PropertyMarker = () => (
  <div className={styles.propertyMarker}><img src="/assets/images/schools/icon-property-marker.svg" /></div>
);

export const SchoolMarker = ({school, clickHandler}) => (
  <React.Fragment>
  <div className={styles.schoolMarker + (school.showInfo ? ' ' + styles.active :'')} onClick={clickHandler}>
    <img src={"/assets/images/schools/" + school.schoolType.toLowerCase() + "_2@2x.png"} alt={`${school.schoolType.toLowerCase()} school marker`}/>
  </div>
  {school.showInfo ?
    <div className={styles.schoolInfo}>
      <div className="d-flex justify-content-between">
        <div className="bold600">{school.schoolName}</div>
        <div>{school.distanceFromTarget}km</div>
      </div>
      <div>{school.schoolAddress && school.schoolAddress != 'null' ? school.schoolAddress : 'Address not found'}</div>
      <div>
        <span className={styles['attr-' + school.schoolType]}>{school.schoolType}</span>
        <span className={styles['attr-Sector']}>{school.schoolSector}</span>
        {school.hasOwnProperty('schoolYearLow') && school.schoolYearHigh ? <span className={styles['attr-Years']}>{school.schoolYearLow == 0 ? 'P' : school.schoolYearLow} - {school.schoolYearHigh}</span> : null}
        <span className={styles['attr-Gender']}>{school.schoolGender == 'M' ? 'Male' : school.schoolGender == 'F' ? 'Female' : 'Combined'}</span>
        <span className={styles['attr-Enrolments']}>{school.schoolEnrolments} Enrolled</span>
      </div>
      {school.schoolWebsite ?
        <div className="mt-2"><a className={styles.infoLink} href={school.schoolWebsite} target="_blank" rel="nofollow noopener noreferrer">Visit school website</a></div>
      : null}
    </div>
  : null}
  </React.Fragment>
);

export const ComparableMarker = ({comparable, clickHandler}) => {
  return (
    <React.Fragment>
    <div className={styles.schoolMarker + (comparable.showInfo ? ' ' + styles.active :'')} onClick={clickHandler}>
      <img src="/assets/images/schools/recent-sale.svg" />
    </div>
    {comparable.showInfo ?
      <div className={styles.comparableCard}>
        <PropertyCard showAvatar={false} property={comparable} />
      </div>
    : null}
    </React.Fragment>
  )
};

export const ExploreMarker = ({explorer, clickHandler}) => {
  let googleURL = 'https://www.google.com/maps/search/?api=1&query=' + explorer.geometry.location.lat() + ',' + explorer.geometry.location.lng() + '&query_place_id=' + explorer.place_id;
  return (
    <React.Fragment>
    <div className={styles.exploreMarker + (explorer.showInfo ? ' ' + styles.active :'')} onClick={clickHandler}>
      <img src="/assets/images/schools/recent-sale.svg" />
    </div>
    {explorer.showInfo ?
      <div className={styles.exploreInfo}>
        <div className="bold600">{explorer.name}</div>
        <div>{explorer.vicinity}</div>
        <div className="mt-2"><a href={googleURL} className={styles.infoLink} target="_blank" rel="nofollow noopener noreferrer">See Ratings, Reviews & Photos on Google</a></div>
      </div>
    : null}
    </React.Fragment>
  )
};

